import * as React from 'react';
import cx from 'classnames';

interface ButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  /**
   *  If added, the button will show an icon before the button's label.
   */

  leftIcon?: React.ReactElement;
  /**
   * If added, the button will show an icon after the button's label.
   */
  rightIcon?: React.ReactElement;

  /**
   * Customize the visual style of the Button
   */
  variant?: 'ghost' | 'solid';

  /**
   * The size of the Button
   */
  size?: 'sm' | 'md' | 'lg';

  /**
   * If true, the button will be disabled/inactive
   */
  disabled?: boolean;

  /**
   * Type of button
   */
  type?: 'submit' | 'button';
}

export default function Button({
  children,
  leftIcon,
  rightIcon,
  variant = 'ghost',
  className,
  size = 'md',
  disabled = false,
  type,
  ...props
}: ButtonProps) {
  return (
    <button
      className={cx('button', className && className, size, variant, {
        'bg-transparent hover:bg-uta-black disabled:bg-transparent disabled:bg-opacity-50 text-uta-black hover:text-white disabled:text-primary-disabled border border-uta-black disabled:border-primary-disabled':
          variant == 'ghost',
        'bg-uta-black hover:bg-white disabled:bg-primary-disabled text-white hover:text-uta-black disabled:text-white disabled:text-opacity-50 border border-uta-black hover:border-uta-black disabled:border-none':
          variant == 'solid',
      })}
      disabled={disabled}
      type={type}
      {...props}
    >
      {leftIcon && leftIcon}

      {children}

      {rightIcon && rightIcon}
    </button>
  );
}
